import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BuyImagesComponent } from './buy-images/buy-images.component';
import { CompanyComponent } from './company/company.component';
import { CopyrightsComponent } from './copyrights/copyrights.component';
import { DownloadAppComponent } from './download-app/download-app.component';
import { FreeImagesComponent } from './free-images/free-images.component';
import { PaymentTypesComponent } from './payment-types/payment-types.component';
// import { SelectLanguageComponent } from './select-language/select-language.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CompanyComponent,
    BuyImagesComponent,
    FreeImagesComponent,
    DownloadAppComponent,
    CopyrightsComponent,
    // SelectLanguageComponent,
    PaymentTypesComponent,
  ],
})
export class FooterComponent {}
